import  React, {createContext} from 'react';

const RatingContext = createContext(null);

export default RatingContext;